import { c as _c } from "react/compiler-runtime";
import { IcoFileText24 } from '@onefootprint/icons';
import { Button } from '@onefootprint/ui';
import { saveAs } from 'file-saver';
import { useTranslation } from 'react-i18next';
type PreviewNotAvailableProps = {
  base64Data: string;
  mimeType: string | null;
  documentName?: string;
};
const base64ToBlob = (base64Data: string, mimeType: string): Blob => {
  const byteCharacters = atob(base64Data);
  const byteArray = Uint8Array.from(byteCharacters, char => char.charCodeAt(0));
  return new Blob([byteArray], {
    type: mimeType
  });
};
const PreviewNotAvailable = t0 => {
  const $ = _c(24);
  const {
    base64Data,
    mimeType,
    documentName
  } = t0;
  const {
    t
  } = useTranslation("document-viewer");
  let t1;
  if ($[0] !== base64Data || $[1] !== documentName || $[2] !== mimeType) {
    t1 = () => {
      const blob = base64ToBlob(base64Data, mimeType ?? "application/octet-stream");
      saveAs(blob, documentName || "document");
    };
    $[0] = base64Data;
    $[1] = documentName;
    $[2] = mimeType;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleDownload = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IcoFileText24 />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <h3 className="text-label-2 text-primary">{t3}</h3>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp2);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <p className="text-body-2 text-secondary">{t5}</p>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <div className="flex flex-col items-center gap-1 text-center">{t4}{t6}</div>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t(_temp3);
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== handleDownload || $[19] !== t8) {
    t9 = <Button onClick={handleDownload}>{t8}</Button>;
    $[18] = handleDownload;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t9) {
    t10 = <div className="flex flex-col items-center justify-center h-full w-full gap-4 p-6">{t2}{t7}{t9}</div>;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};
export default PreviewNotAvailable;
function _temp($) {
  return $.preview.notAvailable.title;
}
function _temp2($_0) {
  return $_0.preview.notAvailable.description;
}
function _temp3($_1) {
  return $_1.preview.notAvailable.downloadButton;
}